import type { AppLocale } from "./index"
import { EXTENDED_PLATE_UI } from "./extendedLocaleUi"
import { PUBLIC_EXTRA_PLATE_UI } from "./publicExtraBasicUi"
import { uzbekLatinToCyrillic } from "./uzbekCyrillic"
import { isExpansionLocale } from "./publicExpansionSignals"
import { EXPANSION_PLATE_UI } from "./publicExpansionBasicUi"

type PlateUiKey = "invalid" | "blocked000"

const catalogs: Partial<Record<AppLocale, Record<PlateUiKey, string>>> = {
  ru: { invalid: "Введите корректный госномер", blocked000: "Регион 000 недоступен" },
  en: { invalid: "Enter a valid license plate", blocked000: "Region 000 is unavailable" },
  es: { invalid: "Introduce una matrícula válida", blocked000: "La región 000 no está disponible" },
  "pt-BR": { invalid: "Digite uma placa válida", blocked000: "A região 000 não está disponível" },
  it: { invalid: "Inserisci una targa valida", blocked000: "La regione 000 non è disponibile" },
  tr: { invalid: "Geçerli bir plaka girin", blocked000: "000 bölgesi kullanılamıyor" },
  uk: { invalid: "Введіть коректний держномер", blocked000: "Регіон 000 недоступний" },
  kk: { invalid: "Дұрыс мемлекеттік нөмірді енгізіңіз", blocked000: "000 аймағы қолжетімсіз" },
  uz: { invalid: "To‘g‘ri davlat raqamini kiriting", blocked000: "000 hududi mavjud emas" },
  id: { invalid: "Masukkan pelat nomor yang valid", blocked000: "Wilayah 000 tidak tersedia" },
  ms: { invalid: "Masukkan nombor plat yang sah", blocked000: "Wilayah 000 tidak tersedia" },
  vi: { invalid: "Nhập biển số hợp lệ", blocked000: "Khu vực 000 không khả dụng" },
  tl: { invalid: "Maglagay ng wastong plate number", blocked000: "Hindi available ang rehiyong 000" },
  hi: { invalid: "मान्य वाहन नंबर दर्ज करें", blocked000: "क्षेत्र 000 उपलब्ध नहीं है" },
  ar: { invalid: "أدخل رقم لوحة صالحًا", blocked000: "المنطقة 000 غير متاحة" },
  fa: { invalid: "یک پلاک معتبر وارد کنید", blocked000: "منطقه ۰۰۰ در دسترس نیست" },
  ur: { invalid: "درست نمبر پلیٹ درج کریں", blocked000: "علاقہ 000 دستیاب نہیں ہے" },
  ...EXTENDED_PLATE_UI,
  ...PUBLIC_EXTRA_PLATE_UI,
}

export function plateUi(locale: AppLocale, key: PlateUiKey): string {
  if (isExpansionLocale(locale)) return EXPANSION_PLATE_UI[locale][key]
  const value = catalogs[locale]?.[key] ?? catalogs.ru![key]
  return locale === "uz" ? uzbekLatinToCyrillic(value) : value
}
